import type { ConsentVariant } from '@/hooks/useCookieConsent';

/**
 * Maps PostHog / URL inputs to the canonical consent banner variant.
 *
 * PostHog multivariate payloads use underscores (`soft_wall`, `progressive_nudge`);
 * app UI and QA overrides use hyphens (`soft-wall`, `progressive-nudge`).
 */
export function resolveConsentVariant(
  flag: string | boolean | undefined,
  search: string,
): ConsentVariant {
  const params = new URLSearchParams(search.startsWith('?') ? search.slice(1) : search);
  const override = params.get('consent_variant');
  if (override === 'control' || override === 'soft-wall' || override === 'progressive-nudge') {
    return override;
  }
  const normalized = typeof flag === 'string' ? flag.replace(/_/g, '-') : '';
  if (normalized === 'soft-wall') return 'soft-wall';
  if (normalized === 'progressive-nudge') return 'progressive-nudge';
  return 'control';
}

export type ConsentVariantSource = 'url_override' | 'posthog' | 'fallback';

export function getConsentVariantDebugInfo(
  flag: string | boolean | undefined,
  search: string,
): { variant: ConsentVariant; source: ConsentVariantSource } {
  const params = new URLSearchParams(search.startsWith('?') ? search.slice(1) : search);
  const override = params.get('consent_variant');
  if (override === 'control' || override === 'soft-wall' || override === 'progressive-nudge') {
    return { variant: override, source: 'url_override' };
  }
  if (flag === undefined) {
    return { variant: 'control', source: 'fallback' };
  }
  const normalized = typeof flag === 'string' ? flag.replace(/_/g, '-') : '';
  if (normalized === 'soft-wall') return { variant: 'soft-wall', source: 'posthog' };
  if (normalized === 'progressive-nudge') return { variant: 'progressive-nudge', source: 'posthog' };
  return { variant: 'control', source: 'fallback' };
}
